function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { compact } from 'lodash-es';
import { Sidebar, SIDEBAR_ITEM_ACTIVE_CLASS } from 'seagull';
import { AnchorLogo, Gift18, PlusCircleLine } from 'seagull/icons';
import BillClientModal from "../../BillClientModal/BillClientModal";
import DisabledBillingTooltip from "../../DisabledBillingTooltip";
import GlobalBillModal from "../../GlobalBillModal/GlobalBillModal";
import { routes } from "../../../constants";
import { useOverlayContext, useStore, useStoreActions } from "../../../contexts";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { Intent } from "../../../infra/access-control";
import { notEmpty } from "../../../infra/utils";
import { UserRole } from "../../../models";
import { useMobileResponsiveness } from "../../../providers/DeviceProvider";
import { selectors } from "../../../store/state-selectors";
import { BusinessSwitcherForSpecificUsers } from "../BusinessSwitcher/BusinessSwitcher";
import styles from "./HomeSidebar.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const getSidebarRoutes = _ref => {
  let {
    MANAGE_API_KEYS,
    CONNECTED_APPS_PAGE,
    SERVICE_TEMPLATE_BUNDLE,
    ALLOW_EDIT_CONTACT
  } = _ref;
  return compact([{
    id: 'dashboard',
    url: routes.vendorDashboard,
    text: 'Dashboard',
    shouldShow: _ref2 => {
      let {
        isVendor,
        hasBusiness
      } = _ref2;
      return isVendor || !hasBusiness;
    }
  }, {
    id: 'proposals',
    text: 'Proposals',
    shouldShow: _ref3 => {
      let {
        isVendor
      } = _ref3;
      return isVendor;
    },
    items: [{
      id: 'sent',
      url: routes.proposalsDashboard,
      text: 'Sent',
      shouldShow: _ref4 => {
        let {
          isVendor
        } = _ref4;
        return isVendor;
      }
    }, {
      id: 'drafts',
      url: routes.draftsDashboard,
      text: 'Drafts',
      shouldShow: _ref5 => {
        let {
          isVendor
        } = _ref5;
        return isVendor;
      }
    }, {
      id: 'archived',
      url: routes.archivedProposals,
      text: 'Archived',
      shouldShow: _ref6 => {
        let {
          isVendor
        } = _ref6;
        return isVendor;
      }
    }, {
      id: routes.proposalTemplates,
      text: 'Templates',
      url: routes.proposalTemplates,
      shouldShow: _ref7 => {
        let {
          isVendor
        } = _ref7;
        return isVendor;
      }
    }, {
      id: routes.proposalDefaults,
      text: 'Default settings',
      url: routes.proposalDefaults,
      shouldShow: _ref8 => {
        let {
          isVendor,
          role
        } = _ref8;
        return isVendor && !!role && role !== UserRole.Member;
      }
    }]
  }, {
    id: 'agreements',
    url: routes.agreementsDashboard,
    text: 'Agreements',
    shouldShow: true
  }, {
    id: 'proposals',
    url: routes.proposalsDashboard,
    text: 'Proposals',
    shouldShow: _ref9 => {
      let {
        isVendor
      } = _ref9;
      return !isVendor;
    }
  }, {
    id: 'billing',
    url: routes.globalBillingHub,
    text: 'Billing',
    shouldShow: _ref10 => {
      let {
        isVendor
      } = _ref10;
      return isVendor;
    }
  }, {
    id: 'invoices',
    url: routes.invoicesDashboard,
    text: 'Invoices',
    shouldShow: true
  }, {
    id: 'payouts',
    url: routes.payoutsDashboard,
    text: 'Payouts',
    shouldShow: _ref11 => {
      let {
        isVendor,
        role
      } = _ref11;
      return isVendor && !!role && role !== UserRole.Member;
    }
  }, {
    id: 'contacts',
    url: routes.contacts,
    text: 'Contacts',
    shouldShow: _ref12 => {
      let {
        isVendor
      } = _ref12;
      return isVendor;
    },
    exact: true
  }, _objectSpread({
    text: 'Services',
    shouldShow: _ref13 => {
      let {
        isVendor,
        role
      } = _ref13;
      return isVendor && !!role && role !== UserRole.Member;
    }
  }, SERVICE_TEMPLATE_BUNDLE ? {
    id: 'allServices',
    items: [{
      id: 'services',
      url: routes.serviceLibrary,
      text: 'Services',
      shouldShow: _ref14 => {
        let {
          isVendor,
          role
        } = _ref14;
        return isVendor && !!role && role !== UserRole.Member;
      },
      exact: true
    }, {
      id: 'bundles',
      url: routes.bundlesLibrary,
      text: 'Bundles',
      shouldShow: _ref15 => {
        let {
          isVendor,
          role
        } = _ref15;
        return isVendor && !!role && role !== UserRole.Member;
      },
      exact: true
    }]
  } : {
    id: 'services',
    url: routes.serviceLibrary,
    exact: true
  }), {
    id: 'reports',
    url: routes.reports,
    text: 'Reports',
    shouldShow: _ref16 => {
      let {
        isVendor,
        role
      } = _ref16;
      return isVendor && !!role && role !== UserRole.Member;
    }
  }, (MANAGE_API_KEYS || CONNECTED_APPS_PAGE) && {
    id: 'integrations',
    text: 'Integrations',
    shouldShow: _ref17 => {
      let {
        isVendor,
        role
      } = _ref17;
      return isVendor && !!role && role !== UserRole.Member;
    },
    items: [{
      id: 'available-apps',
      url: routes.availableApps,
      text: 'Available apps',
      shouldShow: _ref18 => {
        let {
          isVendor,
          role
        } = _ref18;
        return isVendor && !!role && role !== UserRole.Member;
      }
    }, {
      id: 'connected-apps',
      url: routes.connectedApps,
      text: 'Connected apps',
      shouldShow: _ref19 => {
        let {
          isVendor,
          role
        } = _ref19;
        return isVendor && !!role && role !== UserRole.Member && !!CONNECTED_APPS_PAGE;
      }
    }, {
      id: 'api-keys',
      url: routes.anchorApiKeys,
      text: 'API keys',
      shouldShow: _ref20 => {
        let {
          isVendor,
          role
        } = _ref20;
        return isVendor && !!role && role !== UserRole.Member && !!MANAGE_API_KEYS;
      }
    }]
  }, ALLOW_EDIT_CONTACT && {
    id: 'activity-logs',
    url: routes.activityLogs,
    text: 'Activity logs',
    shouldShow: _ref21 => {
      let {
        isVendor
      } = _ref21;
      return !isVendor;
    }
  }, {
    id: 'settings',
    text: 'Settings',
    shouldShow: _ref22 => {
      let {
        role
      } = _ref22;
      return !!role && role !== UserRole.Member;
    },
    items: compact([{
      id: routes.businessDetails,
      text: 'Business details',
      url: routes.businessDetails,
      shouldShow: _ref23 => {
        let {
          role
        } = _ref23;
        return !!role && role !== UserRole.Member;
      }
    }, {
      id: routes.team,
      text: 'Team',
      url: routes.team,
      shouldShow: _ref24 => {
        let {
          role
        } = _ref24;
        return !!role && role !== UserRole.Member;
      }
    }, !MANAGE_API_KEYS && !CONNECTED_APPS_PAGE && {
      id: 'integrations',
      url: routes.availableApps,
      text: 'Integrations',
      shouldShow: _ref25 => {
        let {
          isVendor,
          role
        } = _ref25;
        return isVendor && !!role && role !== UserRole.Member;
      }
    }, {
      id: routes.notifications,
      url: routes.notifications,
      text: 'Notifications',
      shouldShow: _ref26 => {
        let {
          isVendor,
          role
        } = _ref26;
        return isVendor && !!role && role !== UserRole.Member;
      }
    }])
  }, {
    id: 'referrals',
    url: routes.referrals,
    text: 'Refer & Earn',
    shouldShow: _ref27 => {
      let {
        isVendor
      } = _ref27;
      return isVendor;
    },
    icon: /*#__PURE__*/_jsx(Gift18, {})
  }]);
};
const shouldBeCollapsed = (currentPath, clickedRouteId, route) => !(route.id === clickedRouteId) && !('items' in route && route.items.some(item => 'url' in item && currentPath === item.url));
const SidebarLevel = _ref28 => {
  let {
    items,
    logBI
  } = _ref28;
  const location = useLocation();
  const generateCollapseMap = useCallback(uncollapsedGroupId => items.reduce((acc, route) => Object.assign({}, acc, {
    [route.id]: shouldBeCollapsed(location.pathname, uncollapsedGroupId, route)
  }), {}), [items, location]);
  const [collapseMap, setCollapseMap] = useState(generateCollapseMap(null));
  useEffect(() => {
    setCollapseMap(generateCollapseMap(null));
  }, [items, generateCollapseMap]);
  const renderItem = item => {
    if ('url' in item) {
      return /*#__PURE__*/_jsx(Sidebar.Item, {
        as: NavLink,
        to: item.url,
        activeClassName: SIDEBAR_ITEM_ACTIVE_CLASS,
        id: item.id,
        after: item.icon || undefined,
        "data-testid": "home-sidebar-".concat(item.id),
        onClick: event => {
          logBI(10355, {
            screenName: event.currentTarget.id
          });
          setCollapseMap(generateCollapseMap(null));
        },
        children: item.text
      }, item.id);
    } else if ('items' in item) {
      return /*#__PURE__*/_jsx(Sidebar.Group, {
        as: NavLink,
        to: 'url' in item.items[0] && item.items[0].url,
        "data-testid": "home-sidebar-".concat(item.id, "-toggle"),
        id: item.id,
        items: /*#__PURE__*/_jsx(SidebarLevel, {
          items: item.items,
          logBI: logBI
        }),
        collapsed: collapseMap[item.id],
        onClick: _event => {
          logBI(10356, {
            groupName: item.id
          });
          setCollapseMap(generateCollapseMap(!collapseMap[item.id] ? null : item.id));
        },
        children: item.text
      }, item.id);
    }
    return null;
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: items.map(renderItem).filter(notEmpty)
  });
};

/** The new design for the app's sidebar when the user is logged-in. */
export default function HomeSidebar() {
  const overlayContext = useOverlayContext();
  const isVendor = useStore(selectors.user.isVendor);
  const {
    logBI
  } = useStoreActions();
  const {
    isMobileDevice
  } = useMobileResponsiveness();
  const {
    DISABLE_BILLING_SCAN = false,
    MANAGE_API_KEYS,
    CONNECTED_APPS_PAGE,
    SERVICE_TEMPLATE_BUNDLE,
    ALLOW_EDIT_CONTACT
  } = useFeatureFlags();
  const items = useStore(selectors.filterAvailableRoutes(getSidebarRoutes({
    MANAGE_API_KEYS,
    CONNECTED_APPS_PAGE,
    SERVICE_TEMPLATE_BUNDLE,
    ALLOW_EDIT_CONTACT
  })));
  const handleOpenBillClient = async context => {
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref29 => {
        let {
          dismissModal
        } = _ref29;
        return /*#__PURE__*/_jsx(BillClientModal, _objectSpread({
          dismissModal: dismissModal
        }, context));
      }
    });
  };
  const onAddChargeClick = () => {
    logBI(10351);
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref30 => {
        let {
          dismissModal
        } = _ref30;
        return /*#__PURE__*/_jsx(GlobalBillModal, {
          dismissModal: dismissModal,
          handleOpenBillClient: handleOpenBillClient
        });
      }
    });
  };
  const onLinkClick = event => {
    logBI(10355, {
      screenName: event.currentTarget.id
    });
  };
  return /*#__PURE__*/_jsxs(Sidebar, {
    "data-testid": "home-sidebar",
    children: [/*#__PURE__*/_jsx(Sidebar.Header, {
      children: /*#__PURE__*/_jsx(NavLink, {
        id: isVendor ? 'dashboard-via-logo' : 'agreements-via-logo',
        to: "/",
        "data-testid": "home-sidebar-logo-btn",
        onClick: onLinkClick,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.logoContainer,
          children: /*#__PURE__*/_jsx(AnchorLogo, {
            theme: "light",
            height: 44
          })
        })
      })
    }), /*#__PURE__*/_jsx(Sidebar.Content, {
      children: /*#__PURE__*/_jsx(SidebarLevel, {
        items: items,
        logBI: logBI
      })
    }), /*#__PURE__*/_jsx(Sidebar.Footer, {
      children: isMobileDevice ? /*#__PURE__*/_jsx(BusinessSwitcherForSpecificUsers, {
        inSidebar: true
      }) : isVendor && /*#__PURE__*/_jsx(Sidebar.Item, {
        id: "add-charge",
        before: /*#__PURE__*/_jsx(PlusCircleLine, {}),
        intent: Intent.AddCharge,
        "data-testid": "home-sidebar-add-charge",
        onClick: onAddChargeClick,
        disabled: DISABLE_BILLING_SCAN,
        tooltip: DISABLE_BILLING_SCAN ? {
          title: /*#__PURE__*/_jsx(DisabledBillingTooltip, {}),
          placement: 'right'
        } : undefined,
        children: 'Bill client'
      })
    })]
  });
}